import { takeLatest, put, call } from 'redux-saga/effects'
import {
  SIGN_IN_USER_REQUEST_ASYNC,
  SIGN_IN_USER_REQUEST_SUCCESS,
  SIGN_IN_USER_REQUEST_FAILURE,
  GET_USER_REQUEST,
  GET_USER_FAILURE,
  SSO_LOGIN_REQUEST_ASYNC,
  SSO_LOGIN_REQUEST_FAILURE,
} from '../constants/constant.action'
import { api } from '../services'

function* getUserSaga(action) {
  try {
    const payloadData = action.payload.data || action.payload
    const result = yield call(api.getUser, payloadData.authToken)
    if (result.status === 200) {
      const userData = {
        ...payloadData,
        ...result.data,
        tins: result.data.taxId.split(','),
      }
      yield put({ type: SIGN_IN_USER_REQUEST_SUCCESS, payload: userData })
    } else {
      yield put({
        type: GET_USER_FAILURE,
        payload: result.response.data.error,
      })
    }
  } catch (e) {
    yield put({ type: GET_USER_FAILURE })
  }
}

export function* getUserWatcherSaga() {
  yield takeLatest(GET_USER_REQUEST, getUserSaga)
}

function* getSignInUserSaga(action) {
  try {
    const result = yield call(api.getSignInUserRequest, action.payload)
    if (result.status !== 200)
      throw new Error(result.response.data.error.message)
    yield put({ type: GET_USER_REQUEST, payload: result })
  } catch (error) {
    console.dir(error.message)
    yield put({ type: SIGN_IN_USER_REQUEST_FAILURE, payload: error })
  }
}

export function* getSignInUserWatcherSaga() {
  yield takeLatest(SIGN_IN_USER_REQUEST_ASYNC, getSignInUserSaga)
}

function* ssoLoginSaga(action) {
  try {
    const result = yield call(api.ssoLogin, action.payload)
    if (result?.status !== 200) {
      yield put({
        type: SSO_LOGIN_REQUEST_FAILURE,
        payload: result.response.status,
      })
      return
    }
    yield put({
      type: GET_USER_REQUEST,
      payload: result.data,
    })
  } catch (error) {
    console.dir(error.message)
    yield put({ type: SSO_LOGIN_REQUEST_FAILURE, payload: error })
  }
}

export function* ssoLoginWatcherSaga() {
  yield takeLatest(SSO_LOGIN_REQUEST_ASYNC, ssoLoginSaga)
}
